import { Icon } from "@deligoo/ui"
import { IconName } from "@deligoo/ui/src/icons/build"
import clsx from "clsx"

import cls from "./DefList.module.scss"

type DefListProps = {
  children: React.ReactNode[]
  inline?: boolean
  className?: string
}

const DefList = ({ inline = false, className, children }: DefListProps) => {
  return <dl className={clsx(cls.dl, inline && cls.inline, className)}>{children}</dl>
}

type DefListItemProps = {
  title: string
  desc: string
  icon?: IconName
  className?: string
}

const DefListItem = ({ title, desc, icon, className }: DefListItemProps) => {
  return (
    <div className={clsx(cls.item, icon && cls.hasIcon, className)}>
      {icon && (
        <div className={cls.prepend}>
          <Icon name={icon} />
        </div>
      )}
      <dt>{title}</dt>
      <dd>{desc}</dd>
    </div>
  )
}

export { DefList, DefListItem }
